import { render, staticRenderFns } from "./SuggestTherapists.vue?vue&type=template&id=b5b36808&scoped=true&"
import script from "./SuggestTherapists.vue?vue&type=script&lang=js&"
export * from "./SuggestTherapists.vue?vue&type=script&lang=js&"
import style0 from "./SuggestTherapists.vue?vue&type=style&index=0&id=b5b36808&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b36808",
  null
  
)

export default component.exports